<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col lg="12">
        <b-card
          title="Groupes de destinataires"
          class="bg-light shadow"
          title-tag="h6"
        >
          <div class="card-body" v-if="loaded">
            <b-button
              class="mb-3"
              icon
              title="Nouveau groupe"
              @click="openNewGroup()"
              variant="success"
              size="sm"
              ><b-icon-plus-circle-fill></b-icon-plus-circle-fill
            ></b-button>
            <b-table
              fixed
              id="warrantsTable"
              small
              striped
              hover
              :fields="groupsFields"
              :items="list"
            >
              <template v-slot:cell(actions)="data">
                <b-button
                  title="Éditer"
                  icon
                  size="xs"
                  variant="success"
                  @click="openEditGroup(data.item.ID)"
                  ><b-icon-pencil-fill></b-icon-pencil-fill
                ></b-button>
                <b-button
                  title="Gérer les destinataires"
                  class="ml-2"
                  icon
                  size="xs"
                  variant="info"
                  @click="editUsers(data.item.ID)"
                  ><i class="fad fa-users"></i
                ></b-button>
                <b-button
                  v-if="$store.getters.isSuperAdmin"
                  title="Supprimer le groupe"
                  class="ml-2"
                  icon
                  size="xs"
                  variant="danger"
                  @click="deleteGroup(data.item.ID)"
                  ><b-icon-x-square-fill></b-icon-x-square-fill
                ></b-button>
              </template>
            </b-table>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-edit-group"
      title="Modifier le nom du groupe"
      @hidden="resetModal"
      @ok="handleEditOk"
    >
      <form ref="form" @submit.stop.prevent="updateGroup">
        <b-form-group
          label="Nom"
          label-for="name-input"
          invalid-feedback="Nom requis"
          :state="nameState"
          label-size="sm"
        >
          <b-form-input
            id="name-input"
            v-model="group.nom"
            :state="nameState"
            required
            size="sm"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Description"
          label-for="name-input"
          label-size="sm"
        >
          <b-form-input
            id="description-input"
            v-model="group.description"
            size="sm"
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
    <b-modal
      id="modal-new-group"
      title="Créer un nouveau groupe"
      @hidden="resetModal"
      @ok="handleNewOk"
    >
      <form ref="form" @submit.stop.prevent="createGroup">
        <b-form-group
          label="Nom"
          label-for="name-input"
          invalid-feedback="Nom requis"
          :state="nameState"
          label-size="sm"
        >
          <b-form-input
            id="name-input"
            v-model="group.nom"
            :state="nameState"
            size="sm"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Description"
          label-for="name-input"
          label-size="sm"
        >
          <b-form-input
            id="description-input"
            v-model="group.description"
            size="sm"
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import newsletters from "@/services/newsletters.js";
export default {
  name: "NewslettersGroups",
  components: {},
  data() {
    return {
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Module d'envoi de mails massif",
          to: { name: "newsletters" },
        },
        {
          text: "Groupes de destinataires",
          active: true,
        },
      ],
      list: {},
      nameState: null,
      groupsFields: [
        {
          key: "ID",
          label: "Numéro du groupe",
          sortable: true,
          class: "text-center",
          thStyle: { width: "200px" },
        },
        {
          key: "nom",
          label: "Nom",
          sortable: true,
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
        },
        {
          key: "total",
          label: "Nombre de destinataires",
          class: "text-center",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          class: "text-center",
          thStyle: { width: "200px" },
        },
      ],
      group: {
        ID: null,
        nom: "",
        description: "",
      },
      busy: false,
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.busy = true;
      newsletters.groups().then((response) => {
        this.list = response.data;
        this.busy = false;
        this.loaded = true;
      });
    },
    editUsers(id) {
      this.$router.push({name: "newslettersGroupUsers", params: {id : id}})
    },
    openEditGroup(id) {
      let group = this.list.filter((x) => x.ID == id);
      if (group.length !== 1) {
        return false;
      }
      this.group.nom = group[0].nom;
      this.group.ID = id;
      this.group.description = group[0].description;
      this.$bvModal.show("modal-edit-group");
    },
    openNewGroup() {
      this.group.ID = null;
      this.group.nom = "";
      this.group.description = "";
      this.$bvModal.show("modal-new-group");
    },
    resetModal() {
      this.group.nom = "";
      this.group.description = "";
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid;
      return valid;
    },
    handleEditOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.updateGroup();
    },
    handleNewOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.createGroup();
    },
    updateGroup() {
      if (!this.checkFormValidity()) {
        return;
      }
      newsletters.update_group(this.group).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Groupe mis à jour", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
        } else {
          this.$bvToast.toast(response.data.message || "Erreur", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
        this.load();
      });

      this.$nextTick(() => {
        this.$bvModal.hide("modal-edit-group");
      });
    },
    deleteGroup(id) {
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr?", { cancelTitle: "Annuler" })
        .then((ok) => {
          if (!ok) return;
          newsletters.delete_group(id).then((response) => {
            if (response.data.success) {
              this.$bvToast.toast("Groupe supprimé", {
                title: `Recuperator`,
                toaster: "b-toaster-top-right",
                variant: "success",
                autoHideDelay: 2000,
                solid: false,
              });
              this.load();
            }
          });
        });
    },
    createGroup() {
      if (!this.checkFormValidity()) {
        return;
      }
      newsletters.create_group(this.group).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast("Groupe créé", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
        } else {
          this.$bvToast.toast(response.data.message || "Erreur", {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
        this.load();
      });

      this.$nextTick(() => {
        this.$bvModal.hide("modal-new-group");
      });
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>